// ======================================================================
// File Name       : EmailEditUserSearchForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { reduxForm, submit } from 'redux-form';
import CustomButton from '../../components/button/CustomButton';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import RenderField from '../../utils/ReduxFormUtils';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';

class EmailEditUserSearchForm extends React.Component {
  render() {
    const { formSubmit, showSelectGroupDlg, selectedGroupList, groupList } = this.props;

    let groupNameString = null;
    groupNameString = selectedGroupList && selectedGroupList.map((selectedGroup, index) => {
      return (
        <Form.Group key={index} className="form-info" controlId="formInlineName">
          <Col as={Form.Label} sm={3} />
          <Col as={Form.Label} sm={7}>
            {convertNodeGroupToNodeString(selectedGroup.groupSecernId, groupList)}
          </Col>
          <Col sm={2}>
            <Button
              variant="primary"
              className="btn-96"
              onClick={this.props.removeGroup.bind(this, index)}
            >
              削除
            </Button>
          </Col>
        </Form.Group>
      );
    });

    return (
      <Col sm={12}>
        <Form onSubmit={(e) => { 
            e.preventDefault();
            e.stopPropagation();
            this.props.handleSearchBtn(formSubmit);
          }} className='form-horizontal'>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              ユーザー名
            </Col>
            <Col sm={9}>
              <RenderField
                type="text"
                name="userName"
                label="ユーザー名"
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              ログインID
            </Col>
            <Col sm={9}>
              <RenderField
                type="text"
                name="loginId"
                label="ログインID"
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              グループ名
            </Col>
            <Col sm={9}>
              <Button
                variant="primary"
                className="btn-96"
                onClick={showSelectGroupDlg}
              >
                グループ選択
              </Button>
            </Col>
          </Form.Group>
          {groupNameString}
          <Form.Group className="form-info">
            <Col className="form-label" sm={12}>
              <RenderField
                name="dormantState"
                label="休止状態のユーザーも表示する"
                type="checkbox"
              />
            </Col>
          </Form.Group>
          <Row>
            <Col sm={12} className="text-center padding-top-10">
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Row>
        </Form>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'emailEditUserSearchForm',
  onSubmit: submit,
  touchOnChange: true,
  initialValues: {
    userName: '',
    loginId: '',
    groupName: '',
    userAttributeKeyNum: 1,
    userAttributeSearchText: '',
    dormantState: false,
    selectedGroupList: [],
  },
})(EmailEditUserSearchForm);
